export default {
  // function
  setting: 'Click to configure',
  edit: 'Edit',
  submitConfirm: 'Confirm submit cmd+s',
  close: 'Close esc',
  fullScreen: 'Full screen',
  cancelFullScreen: 'Exit full screen',
  jsonIllegal: 'Not a valid json format',
  functionIllegal: 'Not a valid function format',
  objectIllegal: 'Not a valid object format',
  circularRef: 'The object contains a circular reference',
  formatError: 'Format error',
  saved: 'Saved',
  // expression
  valueIllegal:
    'The value is an object, which does not match the setter configured for this property. Please edit it in the "code editing mode" of the property',
  jsExpression: 'Please enter a JS expression',
  // Mixin
  input: 'String Input',
  textarea: 'Multiline String Textarea',
  expression: 'Variable Expression',
  monacoEditor: 'MonacoEditor',
  numberPicker: 'Number NumberPicker',
  bool: 'Boolean Switch',
  datePicker: 'Date DatePicker',
  select: 'Dropdown Select',
  radio: 'Single Choice RadioGroup',
  date: 'Date DatePicker',
  dateYear: 'Year DatePicker',
  dateMonth: 'Month DatePicker',
  dateRange: 'Date Range DatePicker',
  list: 'Array List',
  object: 'Object ObjectButton',
  reactNode: 'Node Type ReactNode',
  typeError:
    'The Types configuration of the Minix component property is invalid, the unsupported type [{type}] is used, please check the component property configuration',
  // expression suggestions
  'help.this': 'Container context object',
  'help.state': 'Container state',
  'help.props': 'Container props',
  'help.context': 'Container context',
  'help.schema': 'Page context object',
  'help.component': 'Component context object',
  'help.constants': 'Application constants object',
  'help.utils': 'Application utils object',
  'help.dataSourceMap': 'Container data source map',
  'help.field': 'Form field object',
};
